import { useToastContext } from "components/alert/ToastContext";
import { Label } from "components/input/Label";
import Documento from "model/documentos/Documento";
import DocumentoSolicitacaoRevisao from "model/documentos/DocumentoSolicitacaoRevisao";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputTextarea } from "primereact/inputtextarea";
import { useLoadingContext } from "provider/LoadingProvider";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import DocumentoSolicitacaoRevisaoService from "service/documentos/DocumentoSolicitacaoRevisaoService";

type Props = {
    visible: boolean;
    onHide: () => void;
    documento: Documento
    onConfirm: () => void;
}

const service = new DocumentoSolicitacaoRevisaoService();
export default function ModalDocumentoSolicitarRevisao(props: Props) {

    const { startLoading, stopLoading } = useLoadingContext();
    const { msgErro, msgAlerta } = useToastContext();
    const [dados, setDados] = useState<DocumentoSolicitacaoRevisao>(new DocumentoSolicitacaoRevisao());

    const { register, clearErrors, setError, formState: { errors } } = useForm();

    useEffect(() => {
        if (props.visible) {
            setDados({ ...dados, documento: props.documento });
        }
    }, [props.visible])

    function handleConfirm() {
        if (!validar()) {
            return;
        }
        startLoading();
        service.incluir(dados).then(() => {
            stopLoading();
            props.onConfirm();
            props.onHide();
        }).catch((error) => {
            stopLoading();
            msgErro("Erro ao solicitar revisão", error?.data?.message || "");
            console.error("Erro ao solicitar revisão:", error);
        });

    }

    function validar() {
        if (!dados.descricao) {
            setError("descricao", { type: "manual", message: "Descrição é Obrigatória" }, { shouldFocus: true })
            return false;
        }
        return true;
    }

    return (
        <Dialog
            header="Solicitar Revisão"
            visible={props.visible}
            baseZIndex={100}
            style={{ width: '500px' }}
            onHide={props.onHide}
            footer={<>
                <Button label="Cancelar" icon="pi pi-times" className="p-button-danger" onClick={props.onHide} />
                <Button label="Solicitar" icon="pi pi-plus" onClick={handleConfirm} />
            </>}
        >
            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.2rem' }}>
                <Label obrigatorio>Descrição</Label>
                <InputTextarea rows={5} maxLength={1000} className={errors.descricao ? "p-invalid" : ""}
                    value={dados.descricao} style={{ width: '100%' }} {...register("descricao", {
                        onChange: (e) => {
                            clearErrors("descricao")
                            setDados({ ...dados, descricao: e.target.value })
                        }
                    })} />
                {errors.descricao && errors.descricao.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.descricao?.message as string}</span> : null}
            </div>

        </Dialog>
    );
}